import * as React from "react";
const SvgMan3Outlined = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M14 7h-4c-1.1 0-2 .9-2 2v6h2v7h4v-7h2V9c0-1.1-.9-2-2-2zM12 1.751 14.248 4 12 6.248 9.75 4z" />
  </svg>
);
export default SvgMan3Outlined;
